<template>
  <el-form
    ref="form"
    :model="dioForm"
    :rules="rules"
    :label-width="getLanguage() === 'zh_CN'? '100px' : '170px'"
    v-loading="loading"
  >
    <el-form-item :label="$t('alarm.alarm_cause')">
      <el-col :span="6">
        <el-checkbox
          :disabled="mode === 'view'"
          v-if="sensor || gateway || display || relay || gas || magnetism"
          :label="$t('integration.abnormal_connection')"
          v-model="dioForm.alarmReason[0]"
          :true-label="1"
          :false-label="0"
        >
        </el-checkbox>
      </el-col>
      <el-col :span="6">
        <el-checkbox
          :disabled="mode === 'view'"
          v-if="sensor || gas || magnetism"
          :label="$t('integration.abnormal_data')"
          :true-label="1"
          :false-label="0"
          v-model="dioForm.alarmReason[1]"
        ></el-checkbox>
      </el-col>
      <!--<el-col :span="6">-->
      <!--  <el-checkbox-->
      <!--    :disabled="mode === 'view'"-->
      <!--    v-if="gateway"-->
      <!--    :label="$t('integration.abnormal_power_failure')"-->
      <!--    :true-label="1"-->
      <!--    :false-label="0"-->
      <!--    v-model="dioForm.alarm_reason[2]"-->
      <!--  ></el-checkbox>-->
      <!--</el-col>-->
      <el-col :span="6">
        <el-checkbox
          :disabled="mode === 'view'"
          v-if="base"
          :label="$t('integration.abnormal_detachment')"
          :true-label="1"
          :false-label="0"
          v-model="dioForm.alarmReason[3]"
        ></el-checkbox>
      </el-col>
    </el-form-item>
    <!--<el-form-item :label="$t('integration.alarm_mode')">-->
    <!--  <el-col :span="6">-->
    <!--    <el-checkbox-->
    <!--      :disabled="mode === 'view'"-->
    <!--      :label="$t('integration.voice')"-->
    <!--      :true-label="1"-->
    <!--      :false-label="0"-->
    <!--      v-model="dioForm.alarmWay[0]"-->
    <!--    ></el-checkbox>-->
    <!--  </el-col>-->
    <!--  <el-col :span="6">-->
    <!--    <el-checkbox-->
    <!--      :disabled="mode === 'view'"-->
    <!--      :label="$t('integration.short_message')"-->
    <!--      :true-label="1"-->
    <!--      :false-label="0"-->
    <!--      v-model="dioForm.alarmWay[1]"-->
    <!--    ></el-checkbox>-->
    <!--  </el-col>-->

    <!--  <el-col :span="6">-->
    <!--    <el-checkbox-->
    <!--      :disabled="mode === 'view'"-->
    <!--      :label="$t('integration.mail')"-->
    <!--      :true-label="1"-->
    <!--      :false-label="0"-->
    <!--      v-model="dioForm.alarmWay[2]"-->
    <!--    ></el-checkbox>-->
    <!--  </el-col>-->
    <!--</el-form-item>-->

    <el-form-item :label="$t('integration.data_strategy')" v-if="base">
      <el-select
        class="icon-margin input-width"
        v-model="dioForm.strategy"
        :popper-append-to-body="false"
      >
        <el-option
          :label="$t(item.title)"
          :value="parseInt(key)"
          v-for="(item, key) in baseDataStrategy"
          :key="key"
        ></el-option>
      </el-select>

      <i
        v-if="baseDataStrategy[dioForm.strategy]"
        class="el-icon-question cursor-pointer"
        :title="baseDataStrategy[dioForm.strategy].desc"
      ></i>
    </el-form-item>

    <el-form-item :label="$t('integration.alarm_switch')" >
      <el-switch
        v-model="dioForm.alarmSwitch"
        active-color="#13ce66"
        inactive-color="#ff4949"
        :active-value="1"
        :inactive-value="0">
      </el-switch>
    </el-form-item>

    <template v-if='dioForm.alarmSwitch === 1'>
      <el-form-item :label="$t('integration.alarm_interval')" >
        <el-input v-model="dioForm.repeatInterval" style="width:80px" ></el-input><span style='margin-left: 20px'>{{$t('public.minute')}}</span>
      </el-form-item>
      <el-form-item  v-if='dioForm.alarmReason[0] === 1'  :label="$t('integration.alarm_offline_delay')">
        <div class="delay-wrapper">
          <div class="abDelay">
            <el-input v-model="dioForm.offlineDelay.num" style="width:80px" type="text"></el-input>
          </div>
          <div class="abDelay">
            <!-- 绑定 v-model，设置默认选中 -->
            <el-select v-model="dioForm.offlineDelay.unit" :placeholder="$t('public.please')" style="width:70px">
              <el-option
                v-for="item in selectArray"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>

      <el-form-item v-if='dioForm.alarmReason[1] === 1'  :label="$t('integration.alarm_data_delay')" >
        <div class="delay-wrapper">
          <div class="abDelay">
            <el-input v-model="dioForm.dataDelay.num" style="width:80px" type="text"></el-input>
          </div>
          <div class="abDelay">
            <!-- 绑定 v-model，设置默认选中 -->
            <el-select v-model="dioForm.dataDelay.unit" :placeholder="$t('public.please')" style="width:70px">
              <el-option
                v-for="item in selectArray"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>


      <el-form-item :label="$t('integration.alarm_object')">
        <!-- 外层容器包裹，保证排版正常 -->
        <div style="display: flex; align-items: flex-start;">
          <!-- 增加/删除按钮放在外面 -->
          <i v-if="mode !== 'view'"
             class="el-icon-plus"
             style="cursor: pointer; margin-right: 10px; margin-top: 8px; font-size: 16px;"
             @click="addUerFn">
          </i>
        </div>
      </el-form-item>

      <el-form-item v-for="(item, index) in dioForm.alertObjectList" :key="index">
        <!-- 列表循环 -->
        <div  style="display: flex; align-items: center; margin-bottom: 8px;">

          <!-- 图标区域 (加了安全判断 ?. 防止报错) -->
          <i class="el-icon-message" style="cursor: pointer; margin-right: 5px;"
             @click="handleChoozeFn(index, 0)"
             :class="(item.way && item.way[0] === 1) ? 'orange' : ''">
          </i>
          <i class="el-icon-chat-dot-round is-disabled" style="cursor: pointer; margin-right: 5px;"
             @click="handleChoozeFn(index, 1)"
             :class="(item.way && item.way[1] === 1) ? 'orange' : ''">
          </i>
          <i class="el-icon-microphone is-disabled" style="cursor: pointer; margin-right: 15px;"
             @click="handleChoozeFn(index, 2)"
             :class="(item.way && item.way[2] === 1) ? 'orange' : ''">
          </i>

          <!-- 我猜这里原本应该有输入框，我帮你补上结构，不然光有图标没法看 -->
          <el-input v-model="item.name" :placeholder="$t('integration.please_enter_the_name')" style="width: 120px; margin-right: 10px;"></el-input>
          <el-input v-model="item.phone" :placeholder="$t('integration.please_enter_the_number')" style="width: 150px; margin-right: 10px;"></el-input>
          <el-input v-model="item.email" :placeholder="$t('integration.please_enter_email')" style="width: 150px; margin-right: 10px;"></el-input>

          <!-- 删除按钮 (附带) -->
          <i v-if="mode !== 'view'" class="el-icon-delete" style="cursor: pointer; color: #F56C6C;" @click="delUserFn(index)"></i>
        </div>

      </el-form-item>

    </template>

    <el-form-item :label="$t('integration.describe')">
      <el-input
        v-if="mode === 'edit'"
        v-model.trim="dioForm.description"
        :autosize="{ minRows: 3, maxRows: 4 }"
        :type="'textarea'"
        style="width: 70%;"
      ></el-input>
      <span v-else>{{ dioForm.description }}</span>
    </el-form-item>


    <!-- 转发平台，海外无 -->
    <!--<el-form-item :label="$t('integration.forwarding_platform')" v-if="sensor">-->
    <!--  <el-select-->
    <!--    v-if="mode === 'edit'"-->
    <!--    v-model="dioForm.forward"-->
    <!--    style="width: 250px"-->
    <!--    :popper-append-to-body="false"-->
    <!--  >-->
    <!--    <el-option-->
    <!--      v-for="(item,index) in forwardPlatform"-->
    <!--      :key="item.id"-->
    <!--      :label="getLanguage() === 'zh_CN'? item.name:(index === 0? item.name: item.encoding)"-->
    <!--      :value="item.id"-->
    <!--    ></el-option>-->
    <!--  </el-select>-->
    <!--  <span v-else>{{ platform }}</span>-->
    <!--</el-form-item>-->

    <!--    监测区间-->
    <el-form-item
      :label="$t('integration.monitoring_interval')"
      prop="probe"
      v-if="sensor || base || coz"
    >
      <i
        class="el-icon-plus"
        v-if="isPulsBool && mode === 'edit'"
        style="cursor: pointer"
        @click="handleClick"
      ></i>

      <template v-if="!isPulsBool">
        <div class="probeClass" v-for="(option, index) in ranges" :key="index">
          <el-select
            v-if="mode === 'edit'"
            v-model="option.unitId"
            style="width: 100px;margin-right:10px"
            @change="changeFn($event, index)"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in renderUnits"
              :key="item.id"
              :disabled="item.disabled"
              :label="$t(item.title)"
              :value="item.id"
            >
              <span
                :title="
                  $t(
                    'integration.a_uom_can_only_correspond_to_one_monitoring_interval'
                  )
                "
                >{{ $t(item.title) }}
              </span>
            </el-option>
          </el-select>
          <el-select
            v-if="mode === 'edit'"
            v-model="option.id"
            style="width: 100px;margin-right:10px"
            @change="changeNameFn($event, index)"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in option.forwardNameArray"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
              <span>
                {{ item.name }}
              </span>
            </el-option>
          </el-select>
          <span v-else> {{ rangeFn(option.id) }}</span>
          <span>{{ option.min }}{{ option.unit }}</span>
          <span v-if="option.unit">~</span>
          <span>{{ option.max }}{{ option.unit }}</span>
          <template v-if="mode === 'edit'">
            <i class="el-icon-plus" style="cursor: pointer" @click="addRow"></i>
            <i
              class="el-icon-delete"
              style="cursor: pointer"
              @click="delRow(index, option)"
            ></i>
          </template>
        </div>
      </template>
    </el-form-item>

    <!-- 缓冲区间 -->
    <el-form-item v-if="sensor || base || coz" :label="$t('integration.buffer_interval')">
      <i
        @click="addBuferRange"
        class="el-icon-plus cursor-pointer"
        v-if="!bufferRanges.length"
      ></i>
      <template v-for="(option, index) in bufferRanges">
        <div :key="index" class="uk-flex uk-flex-middle uk-margin-small-bottom">
          <!--  温湿度 -->
          <el-select
            v-model="option.unitId"
            style="width: 100px;margin-right:10px"
            @change="bufferChangeUnit(option.unitId)"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in renderUnits"
              :key="item.id"
              :label="$t(item.title)"
              :value="item.id"
            />
          </el-select>
          <!-- 区间-->
          <el-select
            v-model="option.probe"
            style="width: 100px;margin-right:10px"
            :popper-append-to-body="false"
            @change="bufferRangeChange(option.probe)"
          >
            <el-option
              v-for="item in rangeCache[option.unitId]"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          <div v-if="option.range">
            {{ option.range.min }}{{ option.range.unit }} ~ {{ option.range.max }}{{ option.range.unit }}
          </div>

          <i
            class="el-icon-plus uk-margin-small-left "
            style="cursor: pointer"
            @click="addBuferRange"
          ></i>
          <i
            class="el-icon-delete uk-margin-small-left"
            style="cursor: pointer"
            @click="deleteBufferRange(index, option)"
          ></i>
        </div>
      </template>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="handleSave" v-if="!useRef"
        >{{ $t('integration.application') }}
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { carrierAssistSet, shareRange } from '@/api/modules/carrier.js'
import { baseDataStrategy } from '@/utils/convert'
import { getLanguage } from '@/lang';
import { TempUtils } from '@/utils/TempUtil.js';
export default {
  // useRef是获取内部数据的方式   使用ref获取 如果使用内部方式获取 那么应用按钮就需要隐藏掉
  props: {
    strategy: {},
    forwardPlatform: {},
    oneAndMore: {},
    scopeId: {},
    units: {},
    useRef: {},
    mode: {
      default: 'edit'
    }
  },
  watch: {
    strategy: {
      handler (newVal) {
        this.dioForm = {}
        this.ranges = []
        this.bufferRanges = []

        this.dioForm = { ...newVal }
        // 设置默认值
        if (!this.dioForm.strategy) {
          this.$set(this.dioForm, 'strategy', 1)
        }
        // 报警原因
        this.$set(
          this.dioForm,
          'alarmReason',
          (newVal.alarmReason || '0000').split('').map(item => parseInt(item))
        )
        // 报警开关
        if (!this.dioForm.alarmSwitch) {
          this.$set(this.dioForm, 'alarmSwitch', 0)
        }
        if (!this.dioForm.repeatInterval) {
          this.$set(this.dioForm, 'repeatInterval', 0)
        }

        // 离线延迟
        if (!this.dioForm.offlineDelay) {
          this.$set(this.dioForm, 'offlineDelay', { num:'',unit:1} );
        }

        // 数据延迟
        if (!this.dioForm.dataDelay) {
          this.$set(this.dioForm, 'dataDelay', { num:'',unit:1});
        }
        // 报警联系人
        if (!this.dioForm.alertObjectList) {
          this.$set(this.dioForm, 'alertObjectList', []);
        }else {
          this.dioForm.alertObjectList.forEach(item => {
            item.way = (item.way|| "000") .split('').map(item => parseInt(item))
          });
        }

        // 报警方式
        this.$set(
          this.dioForm,
          'alarmWay',
          (newVal.alarmWay || '000').split('').map(item => parseInt(item))
        )
        this.filterateUnit()

        // 处理 Alarm Range - 需要在 filterateUnit 之后，确保 renderUnits 已有数据
        if (this.strategy.range && this.strategy.range.length > 0) {
          ;(this.strategy.range || []).forEach((item, index) => {
            if (this.rangeCache[item.unitId]) {
              // 缓存命中时，从缓存中获取原始数据并转换
              const cachedResult = this.rangeCache[item.unitId]
              const unitItem = this.renderUnits.find(u => u.id === item.unitId)
              const tempUnit = unitItem ? unitItem.name : '°C'
              const convertedResult = cachedResult.map(range => {
                const converted = { ...range }
                if (converted.unitId === 1) {
                  converted.min = TempUtils.convertToCelsius(converted.min, tempUnit)
                  converted.max = TempUtils.convertToCelsius(converted.max, tempUnit)
                  converted.unit = tempUnit
                } else {
                  converted.unit = unitItem ? unitItem.name : ''
                }
                return converted
              })
              this.$set(item, 'forwardNameArray', convertedResult)
              // 更新当前选中项的 min/max/unit
              if (item.id) {
                const selected = convertedResult.find(r => r.id === item.id)
                if (selected) {
                  this.$set(item, 'min', selected.min)
                  this.$set(item, 'max', selected.max)
                  this.$set(item, 'unit', selected.unit)
                }
              }
            } else {
              this.loading = true
              // 获取所有监测区间
              shareRange({
                scope: this.scopeId,
                unit: item.unitId
              })
                .then(({ result }) => {
                  // 缓存原始数据（不转换）
                  this.rangeCache[item.unitId] = result.map(r => ({ ...r }))
                  // 转换后显示
                  const unitItem = this.renderUnits.find(u => u.id === item.unitId)
                  const tempUnit = unitItem ? unitItem.name : '°C'
                  const convertedResult = result.map(range => {
                    const converted = { ...range }
                    if (converted.unitId === 1) {
                      converted.min = TempUtils.convertToCelsius(converted.min, tempUnit)
                      converted.max = TempUtils.convertToCelsius(converted.max, tempUnit)
                      converted.unit = tempUnit
                    } else {
                      converted.unit = unitItem ? unitItem.name : ''
                    }
                    this.$set(this.rangeMap, range.id, converted)
                    return converted
                  })
                  this.$set(item, 'forwardNameArray', convertedResult)
                  // 更新当前选中项的 min/max/unit
                  if (item.id) {
                    const selected = convertedResult.find(r => r.id === item.id)
                    if (selected) {
                      this.$set(item, 'min', selected.min)
                      this.$set(item, 'max', selected.max)
                      this.$set(item, 'unit', selected.unit)
                    }
                  }
                })
                .finally(() => (this.loading = false))
            }
          })
        }

        // 处理 bufferRanges - 需要在 filterateUnit 之后，确保 renderUnits 已有数据
        if (newVal.bufferRanges && newVal.bufferRanges.length) {
          newVal.bufferRanges.forEach(range => {
            const unitItem = this.renderUnits.find(u => u.id === range.unitId)
            const tempUnit = unitItem ? unitItem.name : '°C'
            // 创建转换后的 range 对象（不修改原始数据）
            const convertedRange = { ...range }
            if (convertedRange.unitId === 1) {
              convertedRange.min = TempUtils.convertToCelsius(convertedRange.min, tempUnit)
              convertedRange.max = TempUtils.convertToCelsius(convertedRange.max, tempUnit)
              convertedRange.unit = tempUnit
            } else {
              convertedRange.unit = unitItem ? unitItem.name : ''
            }
            // 存入 rangeMap（转换后的数据）
            this.$set(this.rangeMap, range.id, convertedRange)
            this.bufferRanges.push({
              // 单位
              unitId: range.unitId,
              probe: range.id,
              // 区间
              range: convertedRange
            })
          })
        }

        if (this.strategy.range && this.strategy.range.length) {
          // 清空非选中状态
          const array = this.strategy.range.map((item, index) => {
            this.renderUnits.forEach(opt => {
              if (item.unitId === opt.id) {
                this.$set(item, 'unit', opt.name)
                this.$set(opt, 'disabled', true)
              }
            })
            return item
          })
          this.ranges = [...array]
        }
      },
      immediate: true
    },
    'strategy.deviceType': {
      handler () {
        this.filterateUnit()
      }
    }
  },
  computed: {
    // unit单位对应的Map
    unitMap () {
      const map = {}
      if (!this.units) {
        return {}
      }
      this.units.forEach(unit => {
        map[unit.id] = unit
      })
      return map
    },
    isPulsBool () {
      return !(this.ranges && this.ranges.length)
    },
    rules () {
      return {}
    },
    sensor () {
      return this.strategy.status !== 1 && parseInt(this.strategy.deviceCatalog) === 0 || (this.strategy.status == 1 && parseInt(this.strategy.changeDeviceCatalog) === 0)
    },
    gateway () {
      return parseInt(this.strategy.deviceCatalog) === 1 || (this.strategy.status == 1 && parseInt(this.strategy.changeDeviceCatalog) === 1)
    },
    display () {
      return parseInt(this.strategy.deviceCatalog) === 2 || (this.strategy.status == 1 && parseInt(this.strategy.changeDeviceCatalog) === 2)
    },
    relay () {
      return parseInt(this.strategy.deviceCatalog) === 3 || (this.strategy.status == 1 && parseInt(this.strategy.changeDeviceCatalog) === 3)
    },
    base () {
      return parseInt(this.strategy.deviceCatalog) === 4 || (this.strategy.status == 1 && parseInt(this.strategy.changeDeviceCatalog) === 4)
    },
    baseDataStrategy: () => baseDataStrategy,
    // 当前选中的转发平台
    platform () {
      const item = this.forwardPlatform.find(
        item => item.id === parseInt(this.dioForm.forward)
      )

      if (item) {
        return item.name
      }
    },
    gas () {
      return parseInt(this.strategy.deviceCatalog) === 5 || (this.strategy.status == 1 && parseInt(this.strategy.changeDeviceCatalog) === 5)
    },
    magnetism () {
      return parseInt(this.strategy.deviceCatalog) === 6 || (this.strategy.status == 1 && parseInt(this.strategy.changeDeviceCatalog) === 6)
    },
    coz(){
      return (parseInt(this.strategy.deviceCatalog) === 5 && this.strategy.deviceType ===6)
      || (this.strategy.status == 1 && parseInt(this.strategy.changeDeviceCatalog) === 5 && this.strategy.deviceType ===6)
    }

  },
  data () {
    return {
      selectArray: [
        {
          value: 0,
          label: $t('public.second')
        },
        {
          value: 1,
          label: $t('public.minute')
        },
        {
          value: 2,
          label: $t('public.hour')
        }
      ],
      dioForm: {},
      ranges: [],
      bufferRanges: [],
      loading: false,
      // forwardNameArray: [],

      // 用于渲染的units
      renderUnits: [],
      // range缓存 不用每次都重新请求  根据unitId来区分
      rangeCache: {},
      // 区间Map 用rangeId来区分
      rangeMap: {},

      // 报警原因
      alarmArray: [
        {
          type: 'linkEx',
          label: this.$t('device.conn_abnormal'),
          trueLabel: 1,
          falseLabel: 0
        },
        {
          type: 'dataEx',
          label: $t('public.ex_data'),
          trueLabel: 1,
          falseLabel: 0
        },
        {
          type: 'powerEx',
          label: $t('public.ex_power'),
          trueLabel: 1,
          falseLabel: 0
        },
        {
          type: 'xxxEx',
          label: $t('integration.abnormal_detachment'),
          trueLabel: 1,
          falseLabel: 0
        }
      ],
      // 报警方式
      alarmWayArray: [
        {
          type: 'phoneWay',
          label: $t('integration.voice'),
          trueLabel: 1,
          falseLabel: 0
        },
        {
          type: 'textWay',
          label: $t('integration.short_message'),
          trueLabel: 1,
          falseLabel: 0
        },
        {
          type: 'mailWay',
          label: $t('integration.mail'),
          trueLabel: 1,
          falseLabel: 0
        }
      ],
      getLanguage
    }
  },
  methods: {
    /**
     * 删除buffer区间
     */
    deleteBufferRange (index, option) {
      this.bufferRanges.splice(index, 1)
    },
    /**
     * buffer buffer区间被改变
     * @param probe
     */
    bufferRangeChange (probe) {
      const item = this.bufferRanges.find(item => item.probe === probe)
      item.range = this.rangeMap[probe]
    },
    /**
     * 添加缓冲全歼
     */
    addBuferRange () {
      this.bufferRanges.push({
        // 单位
        unitId: null,
        // 区间
        probe: '',
        range: null
      })
    },
    /**
     * 缓冲区间温度被改变
     * @param unitId
     */
    bufferChangeUnit (unitId) {
      if (this.rangeCache[unitId]) {
        return
      }
      shareRange({
        scope: this.scopeId,
        unit: unitId
      }).then(({ result }) => {
        // 缓存原始数据
        this.$set(this.rangeCache, unitId, result.map(r => ({ ...r })))
        // 转换后存入 rangeMap
        const unitItem = this.renderUnits.find(item => item.id === unitId)
        result.forEach(range => {
          const converted = { ...range }
          if (converted.unitId === 1) {
            const tempUnit = unitItem ? unitItem.name : '°C'
            converted.min = TempUtils.convertToCelsius(converted.min, tempUnit)
            converted.max = TempUtils.convertToCelsius(converted.max, tempUnit)
            converted.unit = tempUnit
          } else {
            converted.unit = unitItem ? unitItem.name : ''
          }
          this.$set(this.rangeMap, range.id, converted)
        })
      })
    },

    textFn (id) {
      let str = ''
      this.forwardPlatform.forEach(item => {
        if (item.id === id) {
          str = item.id === 0 ? $t('integration.no_forwarding') : item.name
        }
      })
      return str
    },
    unitIdFn (id) {
      let text = ''
      this.renderUnits.forEach(item => {
        if (id === item.id) {
          text = item.title
        }
      })
      return text
    },
    rangeFn (id) {
      let text = ''
      this.ranges.forEach(item => {
        if (parseInt(id) === parseInt(item.id)) {
          text = item.name
        }
      })
      return text
    },

    unitFn (array, id) {
      let text = ''
      ;(array || []).forEach(item => {
        if (id === item.id) {
          text = item.name
        }
      })
      return text
    },
    async getData () {
      await this.$refs.form.validate()
      const array = (this.ranges || []).map(item => item.id)
      this.dioForm.probe = array.join(',')
      this.dioForm.bufferRange = this.bufferRanges
        .map(item => item.probe)
        .join(',')

      // one
      this.dioForm.devId = this.strategy.devId
      delete this.dioForm.devIds

      const query = { ...this.dioForm }
      query.alarmReason = query.alarmReason.join('')
      query.alarmWay = '000';
      query.carrierId = this.$route.query.id

      if (query.alertObjectList){
        for (let i = 0; i < query.alertObjectList.length; i++) {
          query.alertObjectList[i] = {
            ...query.alertObjectList[i],
            way:query.alertObjectList[i].way.join('')
          }
        }
      }
      delete query.range
      return query
    },
    async handleSave () {
      const query = await this.getData()
      carrierAssistSet(query, this.$route.query.type).then(
        async ({ state }) => {
          this.$message.success('应用成功')
        }
      )
      // 删除所有
      // Object.keys(this.dioForm).forEach(key => {
      //   this.$delete(this.dioForm, key)
      // })
    },
    handleClick () {
      this.ranges.push({
        unitId: '',
        id: '',
        unit: '',
        min: '',
        max: '',
        disabled: false,
        forwardNameArray: []
      })
    },
    changeFn (id, index) {
      this.ranges[index].min = ''
      this.ranges[index].max = ''
      this.ranges[index].id = ''

      this.renderUnits.forEach(item => {
        if (id === item.id) {
          this.ranges[index].unit = item.name
          this.$set(item, 'disabled', true)
        }
        if(this.ranges.findIndex(_ => _.unitId === item.id) === -1){
          this.$set(item, 'disabled', false)
        }
      })
      this.shareUnitFn(id, index)
    },
    shareUnitFn (id, index) {
      shareRange({
        scope: this.scopeId,
        unit: id
      }).then(({ result }) => {
        // 缓存原始数据
        this.rangeCache[id] = result.map(r => ({ ...r }))
        // 转换后显示
        const unitItem = this.renderUnits.find(item => item.id === id)
        const tempUnit = unitItem ? unitItem.name : '°C'
        const convertedResult = result.map(range => {
          const converted = { ...range }
          if (range.unitId === 1) {
            converted.min = TempUtils.convertToCelsius(converted.min, tempUnit)
            converted.max = TempUtils.convertToCelsius(converted.max, tempUnit)
            converted.unit = tempUnit
          } else {
            converted.unit = unitItem ? unitItem.name : ''
          }
          this.$set(this.rangeMap, range.id, converted)
          return converted
        })
        this.ranges[index].forwardNameArray = convertedResult
      })
    },
    changeNameFn (id, index) {
      this.ranges[index].min = ''
      this.ranges[index].max = ''

      this.ranges[index].forwardNameArray.forEach(item => {
        if (id === item.id) {
          this.ranges[index].min = item.min
          this.ranges[index].max = item.max
        }
      })
    },
    addRow () {
      this.ranges.push({
        unitId: '',
        id: '',
        unit: '',
        min: '',
        max: '',

        forwardNameArray: []
      })
    },
    delRow (index, option) {
      this.renderUnits.forEach(item => {
        if (option.unitId === item.id) {
          this.$set(item, 'disabled', false)
        }
      })
      this.ranges.splice(index, 1)
      // if (this.ranges.length === 0) {

      //     this.isPulsBool = true;
      // }
    },
    filterateUnit () {
      if(parseInt(this.strategy.deviceCatalog) === 0 ){
        // 都是温度计 且 1是温度计底座 也是zigbee温度计
        if (
          this.strategy.deviceType === 1 ||
          this.strategy.deviceType === 3 ||
          this.strategy.deviceType === 5
        ) {
          this.renderUnits = JSON.parse(
            JSON.stringify(this.units.filter(item => item.code === 'temp'))
          )
        } else {
          this.renderUnits = JSON.parse(JSON.stringify(this.units))
        }
      }else if(parseInt(this.strategy.deviceCatalog) === 5){
        // 气体--二氧化碳
        if(this.strategy.deviceType === 6){
          this.renderUnits = JSON.parse(
            JSON.stringify(this.units.filter(item => item.code === 'coz'))
          )
        }
      }else{
        this.renderUnits = JSON.parse(JSON.stringify(this.units))

      }

      // 都是温度计 且 1是温度计底座 也是zigbee温度计
      // if (
      //   this.strategy.deviceType === 1 ||
      //   this.strategy.deviceType === 3 ||
      //   this.strategy.deviceType === 5
      // ) {
      //   this.renderUnits = JSON.parse(
      //     JSON.stringify(this.units.filter(item => item.code === 'temp'))
      //   )
      // } else {
      //   this.renderUnits = JSON.parse(JSON.stringify(this.units))
      // }
    },
    addUerFn() {
      this.dioForm.alertObjectList.push({
        way: [0,0,0],
        name: '',
        phone: '',
        email: ''
      });
    },
    delUserFn(index) {
      if (this.dioForm.alertObjectList.length === 1) return this.$message.warning($t('integration.keep_at_least_one'));
      this.dioForm.alertObjectList.splice(index, 1);
    },
    /**
     * 切换告警方式的状态 (0 和 1 互换)
     * @param {Object} item - 当前行的数据对象 (例如: { name: '张三', way: [0, 1, 0] })
     * @param {Number} num  - 要切换的序列索引 (例如: 0代表消息, 1代表聊天, 2代表麦克风)
     */
    handleChoozeFn(index, num) {
      const currentValue = this.dioForm.alertObjectList[index].way[num];
      const newValue = currentValue === 0 ? 1 : 0;

      // 第一个参数：要修改的数组/对象
      // 第二个参数：索引或属性名
      // 第三个参数：新值
      this.$set(this.dioForm.alertObjectList[index].way, num, newValue);
    },
    startFn(str, num) {
      if (!str) return;
      const array = str.split(',');
      return str[num] === 1 ? 'orange' : '';
    },
    titleFn(status, num) {
      let str = '';
      const array = status.split(',');
      for (const item of this.iconArray) {
        if (item.id === num) {
          str = array.includes(num) ? item.activeLabel : item.label;
          break;
        }
      }
      return str;
    },
  },

}
</script>

<style lang="scss" scoped>
.probeClass {
  margin-bottom: 10px;

  span {
    margin-right: 5px;
  }

  i {
    margin-left: 10px;
  }
}
.orange {
  color: orange;
}
/* 让包裹容器变成弹性盒模型，内部元素横向排列 */
.delay-wrapper {
  display: flex;
  align-items: center; /* 垂直居中对齐 */

  .abDelay {
    /* 如果两个控件之间需要一点间距，可以加右边距 */
    margin-right: 10px;
  }
}
/* 置灰且不可点击的样式 */
.is-disabled {
  color: #C0C4CC !important; /* Element UI 默认的禁用灰色，也可以用 #999 */
  cursor: not-allowed !important; /* 鼠标悬停显示禁止符号 */
  pointer-events: none; /* 彻底屏蔽点击事件，即使不写 @click.prevent 也点不了 */
}

</style>
